/**
 * Copyright IBM Corp. 2022, 2026
 */

import { Suspense } from 'react'
import { Button } from '@hashicorp/mds-react'
import s from './style.module.css'

interface BlueskyOEmbed {
	url: string
	author_name: string
	author_url: string
	html: string
	width: number
	height: number | null
	type: string
	cache_age: string
	provider_name: string
	provider_url: string
	version: string
}

export default async function BlueskyEmbed({ url }) {
	const res = await fetch(`https://embed.bsky.app/oembed?url=${url}`, {
		method: 'GET',
	})
	const embedData: BlueskyOEmbed = await res.json()

	const darkModeHtml = embedData.html.replace(
		'<blockquote ',
		'<blockquote data-bluesky-embed-color-mode="dark" ',
	)

	return (
		<div className={s.blueskyEmbed}>
			<Suspense
				fallback={
					<div className={s.fallback}>
						<Button
							type="button"
							href={url}
							isHrefExternal={true}
							text="Visit Bluesky post"
							icon="external-link"
							iconPosition="trailing"
							color="secondary"
						/>
					</div>
				}
			>
				<div dangerouslySetInnerHTML={{ __html: darkModeHtml }} />
			</Suspense>
		</div>
	)
}
